<template>
  <form action>
    <div class="modal-card" style="width: 12cm">
      <header class="modal-card-head">
        <p class="modal-card-title">Project Details</p>
      </header>
      <section class="modal-card-body" ref="createProjectRef">
        <b-field label="Naam Project">
          <b-input type="text" placeholder="Naam" required v-model="projectData.name"></b-input>
        </b-field>
        <b-field label="Stad">
          <b-input type="text" placeholder="Stad" required v-model="projectData.city"></b-input>
        </b-field>
        <b-field label="Adres">
          <b-input type="text" placeholder="Adres" required v-model="projectData.address"></b-input>
        </b-field>
        <b-field label="Postcode">
          <b-input
            pattern="[1-9][0-9]{3}[A-Z]{2}"
            type="textArea"
            placeholder="Postcode"
            required
            oninvalid="this.setCustomValidity('Postcode Format is 1234AA')"
            onchange="this.setCustomValidity('')"
            v-model="projectData.zipCode"
          ></b-input>
        </b-field>
        <b-field label="Land">
          <b-input type="text" placeholder="Land" required :value="land"></b-input>
        </b-field>
        <b-field label="Organisatie">
          <b-input type="text" placeholder="Adres" required :value="organisatie"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary" @click.prevent="createProject()">Maak aan</button>
      </footer>
    </div>
  </form>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      land: 'Nederland',
      organisatie: 'Atlas Techrin International',
      projectData: {
        name: '',
        address: 'Willem Fenengastraat 25',
        city: 'Amsterdam',
        countryCode: 'nl',
        organizationId: 1,
        zipCode: '1096BL'
      }
    }
  },
  methods: {
    async createProject() {
      const pref = this.$refs.createProjectRef.getElementsByTagName('input')
      let hasError = false
      for (let i = 0; i < pref.length; i++) {
        if (!pref[i].validity.valid) {
          hasError = true
        }
      }
      if (!hasError) {
        this.$emit('succeed', this.projectData)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/CreateProjectModal.vue